import { AfterContentChecked, Directive, ElementRef, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[fuseIfOnDom]'
})
export class FuseIfOnDomDirective implements AfterContentChecked {
  public isCreated = false;

  constructor(
    private elementRef: ElementRef,
    private templateRef: TemplateRef<any>,
    private viewContainerRef: ViewContainerRef
  ) {
  }

  ngAfterContentChecked(): void {
    if (document.body.contains(this.elementRef.nativeElement) && !this.isCreated) {
      setTimeout(() => {
        this.viewContainerRef.createEmbeddedView(this.templateRef);
      }, 300);
      this.isCreated = true;
    }
    else if (this.isCreated && !document.body.contains(this.elementRef.nativeElement)) {
      this.viewContainerRef.clear();
      this.isCreated = false;
    }
  }
}
